import { render, staticRenderFns } from "./SplineAreaChart.vue?vue&type=template&id=8faff8c6&scoped=true&"
import script from "./SplineAreaChart.vue?vue&type=script&lang=ts&"
export * from "./SplineAreaChart.vue?vue&type=script&lang=ts&"
import style0 from "./SplineAreaChart.vue?vue&type=style&index=0&id=8faff8c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faff8c6",
  null
  
)

export default component.exports